import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import { assertsString } from "~/submodules/assertsString";

export function WithStripeElement<P>(Component: React.ComponentType<P>) {
  const stripeApiKey = process.env.NEXT_PUBLIC_STRIPE_API_KEY;
  assertsString(stripeApiKey, "NEXT_PUBLIC_STRIPE_API_KEY is not set.");
  const stripe = loadStripe(stripeApiKey);

  const fc: React.FC<P> = (props, ...args) => (
    <Elements stripe={stripe}>
      <Component {...args} {...props} />
    </Elements>
  );

  return fc;
}
